<ion-fab vertical="bottom" horizontal="start" slot="fixed" *ngIf="vani.show">
  <img class="vani" (click)="intro()" src="./assets/imgs/vani.png" width="70" height="auto">
</ion-fab>